var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("pages-wrapper", [
    _c(
      "div",
      { staticClass: "payment" },
      [
        _c("h1", { staticClass: "payment-title" }, [
          _vm._v("\n      " + _vm._s(_vm.pageTitle) + "\n    ")
        ]),
        _c("div", {
          staticClass: "payment-content",
          domProps: { innerHTML: _vm._s(_vm.GET_FRAGMENT("payment_main")) }
        }),
        _c("div", { staticClass: "payment-hint" }, [
          _c("ol", [
            _c("li", [
              _c("span", [
                _vm._v("Номер карты ‒ 16 цифр на лицевой стороне карты")
              ])
            ]),
            _c("li", [_c("span", [_vm._v("Срок действия в формате ММ/ГГ")])]),
            _c("li", [
              _c("span", [
                _vm._v(
                  "Имя держателя карты в точности так же, как они написаны на карте"
                )
              ])
            ]),
            _c("li", [
              _c("span", [
                _vm._v("CVC/CVV ‒ цифровой номер на обратной стороне карты.")
              ])
            ])
          ]),
          _c("img", { attrs: { src: _vm.cardImage, alt: "cardImage" } })
        ]),
        _c("p", [
          _vm._v(
            "\n      Передача этих сведений производится с соблюдением всех необходимых мер безопасности. Данные будут переданы только на авторизационный сервер Банка по защищенному каналу (протокол SSL 3.0). Информация передается в зашифрованном виде и сохраняется только на специализированном сервере платежной системы. Сайты и магазины не знают и не хранят данные по вашей банковской карте.\n    "
          )
        ]),
        _c("div", { staticClass: "payment-systems" }, [
          _c("p", [
            _vm._v("Мы принимаем к оплате банковские карты платежных систем:")
          ]),
          _c("img", {
            staticClass: "payment-systems__img",
            attrs: { src: _vm.systemImage, alt: "systems" }
          })
        ]),
        _c("order-support", [
          _vm._v(
            "\n      С вопросами обращайтесь в службу поддержки пользователей FUNDAY по почте  "
          ),
          _c("a", { attrs: { href: "mailto:helpme@fundayshop.com" } }, [
            _vm._v("helpme@fundayshop.com")
          ]),
          _vm._v(" или по телефону "),
          _c("a", { attrs: { href: "tel:+78007700101" } }, [
            _vm._v("8 800 770-01-01")
          ]),
          _vm._v(" (по России бесплатно), с 7:00 до 22:00 (мск)\n    ")
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }